/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsStatisticsSecretariat } from '../../models/submissions-statistics-secretariat';

export interface GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Params {
  org: string;
}

export function getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet(http: HttpClient, rootUrl: string, params: GetStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsStatisticsSecretariat>>> {
  const rb = new RequestBuilder(rootUrl, getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsStatisticsSecretariat>>;
    })
  );
}

getStatisticsForSubmissionsCyclesApiV2SecretariatSubmissionsOrgSubmissionsCyclesStatisticsGet.PATH = '/api/v2/secretariat/submissions/{org}/submissions-cycles/statistics';
